<template>
  <div class="user-details-page">
        <div class="titolo-card">
          <h1>Dettagli Utente</h1>
        </div>

        <AdminPasswordReset
          v-if="passwordResetUserId"
          :key="passwordResetUserId"
          :user-id="passwordResetUserId"
        />

        <div class="user-details-container" v-if="userDetails">
          <form @submit.prevent="updateUserDetails">
      <div class="grid-container">
        <!-- Prima riga -->

        <div class="grid-item">
  <label for="complUtenteAll">Complessità allenamento:</label>
  <select 
    id="complUtenteAll" 
    v-model="userDetails.complUtenteAll" 
    class="user-input"
    :class="{
      'green-background': userDetails.complUtenteAll === 'Semplice',
      'orange-background': userDetails.complUtenteAll === 'Intermedio',
      'red-background': userDetails.complUtenteAll === 'Complesso'
    }"
  >
    <option disabled value="">Seleziona uno stato</option>
    <option value="Semplice">Semplice</option>
    <option value="Intermedio">Intermedio</option>
    <option value="Complesso">Complesso</option>
  </select>
</div>

<div class="grid-item">
  <label for="complUtenteAli">Complessità alimentazione:</label>
  <select 
    id="complUtenteAli" 
    v-model="userDetails.complUtenteAli" 
    class="user-input"
    :class="{
      'green-background': userDetails.complUtenteAli === 'Semplice',
      'orange-background': userDetails.complUtenteAli === 'Intermedio',
      'red-background': userDetails.complUtenteAli === 'Complesso'
    }"
  >
    <option disabled value="">Seleziona uno stato</option>
    <option value="Semplice">Semplice</option>
    <option value="Intermedio">Intermedio</option>
    <option value="Complesso">Complesso</option>
  </select>
</div>

<div class="grid-item">
          <label for="email">Email:</label>
          <input type="text" id="email" v-model="userDetails.email" class="user-input">
        </div>

        <div class="grid-item">
          <label for="name">Nome:</label>
          <input type="text" id="name" v-model="userDetails.name" class="user-input">
        </div>
        <div class="grid-item">
          <label for="surname">Cognome:</label>
          <input type="text" id="surname" v-model="userDetails.surname" class="user-input">
        </div>


        

        <div class="grid-item">
          <label for="phone">Telefono:</label>
          <input
            type="tel"
            id="phone"
            v-model="userDetails.phone"
            class="user-input"
            inputmode="tel"
            autocomplete="tel"
            pattern="[+0-9 ()-]{8,24}"
          >
        </div>

        <div class="grid-item">
          <label for="genere">Genere:</label>
          <input type="text" id="genere" v-model="userDetails.genere" class="user-input">
        </div>


        <!-- Terza  riga -->
        <div class="grid-item">
          <label>Data di nascita:</label>
          <div class="birthdate-group">
            <select v-model="birthdateParts.day" class="user-input" aria-label="Giorno di nascita">
              <option value="">GG</option>
              <option v-for="opt in DAY_OPTIONS" :key="opt.value" :value="opt.value">
                {{ opt.label }}
              </option>
            </select>
            <select v-model="birthdateParts.month" class="user-input" aria-label="Mese di nascita">
              <option value="">MM</option>
              <option v-for="opt in MONTH_OPTIONS" :key="opt.value" :value="opt.value">
                {{ opt.label }}
              </option>
            </select>
            <select v-model="birthdateParts.year" class="user-input" aria-label="Anno di nascita">
              <option value="">AAAA</option>
              <option v-for="opt in YEAR_OPTIONS" :key="opt" :value="opt">
                {{ opt }}
              </option>
            </select>
          </div>
        </div>

        <div class="grid-item">
          <label for="dataAcquistoCsen">Data acquisto Csen:</label>
          <div class="input-status-row">
            <input
              type="date"
              id="dataAcquistoCsen"
              v-model="csenPurchaseInput"
              class="user-input"
              :disabled="csenHasOrderDate"
              :title="csenHasOrderDate ? 'Data da ordine CSEN' : ''"
            >
            <span class="status-icon" :class="csenInfo.className" :title="csenInfo.label">
              <span class="material-icons">{{ csenInfo.icon }}</span>
            </span>
            <span class="status-text" :class="csenInfo.className">{{ csenInfo.label }}</span>
          </div>
        </div>

  <div class="grid-item">
          <label for="indirizzo">Indirizzo:</label>
          <input type="text" id="indirizzo" v-model="userDetails.indirizzo" class="user-input">
        </div>

        <div class="grid-item">
          <label for="cap">Cap:</label>
          <input type="text" id="cap" v-model="userDetails.cap" class="user-input">
        </div>



  <div class="grid-item">
          <label for="regione">Regione:</label>
          <input type="text" id="regione" v-model="userDetails.regione" class="user-input">
        </div>


        <!-- Seconda riga -->
        <div class="grid-item">
          <label for="provincia">Provincia:</label>
          <input type="text" id="provincia" v-model="userDetails.provincia" class="user-input">
        </div>
        <div class="grid-item">
          <label for="comune">Comune:</label>
          <input type="text" id="comune" v-model="userDetails.comune" class="user-input">
        </div>

        <div class="grid-item">
          <label for="luogoNascita">Luogo di nascita:</label>
          <input type="text" id="luogoNascita" v-model="userDetails.luogoNascita" class="user-input">
        </div>

        <div class="grid-item">
          <label for="italiano">Cittadino italiano:</label>
          <input type="text" id="italiano" v-model="userDetails.italiano" class="user-input">
        </div>


        <div class="grid-item">
  <label for="studio">
    Studio<span v-if="userDetails.studioOriginal"> (ex {{ userDetails.studioOriginal }})</span>:
  </label>
  <select id="studio" v-model="userDetails.studio" class="user-input">
    <option disabled value="">Seleziona uno studio</option>
    <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
    <option value="FF Genova">FF Genova</option>
    <option value="FF Bologna">FF Bologna</option>
    <option value="FF Bari">FF Bari</option>
    <option value="FF Pescara">FF Pescara</option>
    <option value="FF Firenze">FF Firenze</option>
    <option value="FF Torino">FF Torino</option>
    <option value="FF Napoli">FF Napoli</option>
    <option value="FF Milano">FF Milano</option>
    <option value="FF Roma">FF Roma</option>
    <option value="FF Salerno">FF Salerno</option>
    <option value="FF Cagliari">FF Cagliari</option>
    <option value="FF Milano Citta Studi">FF Milano Città Studi</option>
    <option value="FF Salerno">FF Salerno</option>
    <option value="FF Roma Eur">FF Roma Eur</option>
    <option value="FF Milano Sempione">FF Milano Sempione</option>
    <option value="FF Padova">FF Padova</option>
  </select>
</div>


<div class="grid-item">
  <label for="statoUtente">Stato Utente:</label>
  <select id="statoUtente" v-model="userDetails.statoUtente" class="user-input">
    <option disabled value="">Seleziona uno stato</option>
    <option value="Nuovo Acquisto">Nuovo Acquisto</option>
    <option value="Nuovo">Nuovo</option>
    <option value="Rinnovo">Rinnovo</option>
    <option value="Attivo">Attivo</option>
    <option value="Sospeso">Sospeso</option>
    <option value="Inattivo">Inattivo</option>
  </select>
</div>

<div
  class="grid-item full-width operational-hold-card"
  :class="{ 'operational-hold-card--active': operationalHoldActive }"
>
  <div class="operational-hold-card__header">
    <div>
      <label class="operational-hold-card__title">Sospensione operativa</label>
      <p class="operational-hold-card__subtitle">
        {{ operationalHoldActive ? operationalHoldSummary : 'Utente visibile nei flussi operativi standard' }}
      </p>
      <p v-if="operationalHoldMeta" class="operational-hold-card__meta">
        {{ operationalHoldMeta }}
      </p>
    </div>
    <span class="operational-hold-badge" :class="{ 'operational-hold-badge--active': operationalHoldActive }">
      {{ operationalHoldActive ? 'Sospeso' : 'Attivo' }}
    </span>
  </div>

  <div class="operational-hold-grid">
    <div class="operational-hold-field">
      <label for="operationalHoldReason">Motivo</label>
      <select
        id="operationalHoldReason"
        v-model="operationalHoldForm.reason"
        class="user-input operational-hold-select"
        :disabled="operationalHoldSaving"
      >
        <option
          v-for="reason in operationalHoldReasons"
          :key="reason.value"
          :value="reason.value"
        >
          {{ reason.label }}
        </option>
      </select>
    </div>

    <div class="operational-hold-field operational-hold-field--wide">
      <label for="operationalHoldNote">Nota interna</label>
      <textarea
        id="operationalHoldNote"
        v-model="operationalHoldForm.note"
        class="user-textarea operational-hold-note"
        :disabled="operationalHoldSaving"
        placeholder="Motivo o contesto della sospensione"
        rows="1"
      ></textarea>
    </div>
  </div>

  <div class="operational-hold-options">
    <label class="operational-hold-check">
      <input
        v-model="operationalHoldForm.hideFromOperationalLists"
        type="checkbox"
        :disabled="operationalHoldSaving"
      >
      <span>Nascondi da liste operative</span>
    </label>
    <label class="operational-hold-check">
      <input
        v-model="operationalHoldForm.suppressNotifications"
        type="checkbox"
        :disabled="operationalHoldSaving"
      >
      <span>Sospendi notifiche automatiche</span>
    </label>
    <label class="operational-hold-check">
      <input
        v-model="operationalHoldForm.stopManualInstallments"
        type="checkbox"
        :disabled="operationalHoldSaving"
      >
      <span>Metti in STOP le rate manuali collegate</span>
    </label>
  </div>

  <div class="operational-hold-actions">
    <button
      type="button"
      class="button-container button-blu operational-hold-button"
      :disabled="operationalHoldSaving"
      @click="saveOperationalHold"
    >
      {{ operationalHoldSaving ? 'Salvataggio...' : (operationalHoldActive ? 'Aggiorna sospensione' : 'Sospendi operatività') }}
    </button>
    <button
      v-if="operationalHoldActive"
      type="button"
      class="button-container operational-hold-button operational-hold-button--restore"
      :disabled="operationalHoldSaving"
      @click="clearOperationalHold"
    >
      Riattiva operatività
    </button>
    <span v-if="operationalHoldFeedback" class="operational-hold-feedback">
      {{ operationalHoldFeedback }}
    </span>
  </div>
</div>

<div class="grid-item">
  <label for="influencerToggle">Influencer:</label>
  <div class="influencer-toggle-row" :class="{ 'influencer-toggle-row--active': userDetails.influencer }">
    <label class="influencer-toggle" for="influencerToggle">
      <input
        id="influencerToggle"
        v-model="userDetails.influencer"
        type="checkbox"
        :disabled="influencerSaving"
        @change="updateInfluencerStatus($event.target.checked)"
      >
      <span class="influencer-toggle__slider"></span>
      <span class="influencer-toggle__text">{{ userDetails.influencer ? 'Attivo' : 'Non attivo' }}</span>
    </label>
    <span v-if="influencerSaving" class="influencer-toggle__saving">Salvataggio...</span>
  </div>
</div>



<div class="grid-item full-width">
          <label for="codFiscale">Codice fiscale:</label>
          <input type="text" id="codFiscale" v-model="userDetails.codFiscale" class="user-input">
        </div>

        <div class="grid-item full-width">
  <label for="privacyStatus">Privacy per Videocall con Nutrizioniste:</label>
  <input type="text" id="privacyStatus" :value="privacyStatus" class="user-input" disabled />
</div>

         <!-- Campo link dropbox che si estende su due colonne -->
         <div class="grid-item full-width">
  <label for="linkdrop">Link Cartella Dropbox:</label>
  <div class="input-button-container">
    <input type="text" id="linkdrop" v-model="userDetails.linkdrop" class="user-input">
    <button type="button" @click.prevent="openDropboxLink" class="open-link-btn">Apri Link Dropbox</button>
  </div>
</div>


<div class="grid-item full-width">
          <label for="senzPensieri">Senza Pensieri:</label>
          <input type="text" id="senzPensieri" v-model="userDetails.senzPensieri" class="user-input">
        </div>

        <div class="grid-item full-width fusco-card">
          <div class="fusco-card__header">
            <div>
              <p class="fusco-card__eyebrow">Questionario Programmi</p>
              <h3 class="fusco-card__title">Giampaolo Fusco</h3>
            </div>
            <span v-if="fuscoData.updatedAt && !fuscoError" class="fusco-status">
              Aggiornato {{ formatDate(fuscoData.updatedAt) }}
            </span>
          </div>

          <div v-if="fuscoLoading" class="fusco-state">Caricamento dati dal questionario…</div>
          <div v-else-if="fuscoError" class="fusco-state fusco-state--error">{{ fuscoError }}</div>
          <div v-else-if="fuscoHasData" class="fusco-card__grid">
            <div class="fusco-field">
              <span class="fusco-label">Nome e cognome</span>
              <p class="fusco-value">{{ fuscoData.nomeCognome || 'Non indicato' }}</p>
            </div>
            <div class="fusco-field">
              <span class="fusco-label">Età</span>
              <p class="fusco-value">{{ fuscoAgeLabel || '—' }}</p>
            </div>
            <div class="fusco-field fusco-field--full">
              <span class="fusco-label">Note</span>
              <p class="fusco-value">{{ fuscoData.note || 'Nessuna nota inserita' }}</p>
            </div>
          </div>
          <div v-else class="fusco-state">Nessun dato del questionario disponibile.</div>
        </div>


              <!-- Notes section -->
    <div class="grid-item">
      <label for="notes">Note Generali:</label>
                <textarea id="notes" v-model="userDetails.notes" class="user-textarea"></textarea>
    </div>  
    <div class="half-width">
      <label for="noteAlimentazione">Note Alimentazione:</label>
      <textarea id="noteAlimentazione" v-model="userDetails.noteAlimentazione" class="user-textarea"></textarea>
    </div>

    <div class="half-width">
      <label for="noteAllenamento">Note Allenamento:</label>
      <textarea id="noteAllenamento" v-model="userDetails.noteAllenamento" class="user-textarea"></textarea>
    </div>

    <section v-if="passwordResetUserId" class="grid-item full-width profile-programme-note" aria-label="Note monitoraggio percorsi">
      <UserExpiringNote
        :key="passwordResetUserId"
        :user-id="passwordResetUserId"
        :user-name="[userDetails.name, userDetails.surname].filter(Boolean).join(' ')"
        label="Note monitoraggio percorsi"
        highlight-filled
      />
    </section>

            </div>


            <div class="button-actions">
  <button type="submit" class="button-container staff-button-positive">Aggiorna Dettagli</button>

  <div class="button-inline-group">
    <!--<button 
      type="button"
      @click.prevent="handleSave" 
      class="button-container button-blu"
      :disabled="isSaving"
    >
      Salva Invio Giornata
    </button>-->

    <button
      type="button"
      class="icon-button"
      @click="openInviiModal"
      title="Visualizza tutti gli invii di giornata"
      aria-label="Visualizza tutti gli invii di giornata"
    >
      <svg
        class="icon-compact"
        viewBox="0 0 24 24"
        role="presentation"
        focusable="false"
        aria-hidden="true"
      >
        <path
          d="M4 6h5l2 2h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7c0-.55.45-1 1-1Zm1 8h14v-1H5v1Zm0-3h14v-1H5v1Z"
          fill="currentColor"
        />
      </svg>
      <span class="sr-only">Storico invii di giornata</span>
    </button>
  </div>
</div>



<!--<div class="check-section">
  <div class="grid-item full-width">
    <label for="noteCheck">Note del Check:</label>
    <textarea 
      id="noteCheck" 
      v-model="userDetails.noteCheck" 
      class="user-textarea"
      placeholder="Inserisci le note del check…"
    ></textarea>
  </div>

  <div class="flex-row gap-2">
    <div class="grid-item half-width">
      <label for="dafarein">Da fare in:</label>
      <select id="dafarein" v-model="userDetails.dafarein" class="user-input">
        <option disabled value="">Seleziona luogo</option>
        <option value="studio">Studio</option>
        <option value="online">Online</option>
      </select>
    </div>

    <div class="grid-item half-width">
      <label for="assignedEmail">Assegnato a:</label>
      <input
        type="text"
        id="assignedEmail"
        v-model="userDetails.assignedEmail"
        class="user-input"
        placeholder="(vuoto di default)"
      />
    </div>
  </div>

  <button 
    @click.prevent="sendCheck" 
    class="button-container button-blu"
  >
    Invia Check
  </button>
  </div>
-->



    </form>
        </div>
        <div v-else class="loading-message">
          Caricamento dettagli utente...
        </div>

  <div
    v-if="showInviiModal"
    class="modal-backdrop"
    @click.self="closeInviiModal"
  >
    <div class="modal">
      <div class="modal-header">
        <h3 class="modal-title">Storico invii di giornata</h3>
        <button type="button" class="modal-close" @click="closeInviiModal" aria-label="Chiudi storico invii">×</button>
      </div>

      <div v-if="inviiLoading" class="modal-state">Caricamento…</div>
      <div v-else-if="inviiError" class="modal-state error">{{ inviiError }}</div>

      <ul v-else-if="inviiList.length" class="modal-list">
        <li
          v-for="(invio, index) in inviiList"
          :key="invio.id || index"
          class="modal-entry"
          :class="{ 'modal-entry--colored': hasRowColor(invio) }"
          :style="getRowColorStyle(invio)"
        >
          <div class="modal-entry-index">#{{ index + 1 }}</div>
          <div class="modal-entry-content">
            <p class="modal-entry-date">
              Invio: {{ formatDate(invio.createdAt) || 'Data non disponibile' }}
            </p>
            <p class="modal-entry-delivery">
              Consegna: {{ formatDateOnly(invio.dataConsegna) || 'Data non disponibile' }}
            </p>
            <p class="modal-entry-meta">
              Videocall: {{ getVideocallLabel(invio) || 'Non impostata' }}
            </p>
            <p class="modal-entry-meta">
              Colore: {{ getRowColorLabel(invio) }}
            </p>
            <p
              v-if="invio.notes || invio.noteAlimentazione || invio.noteAllenamento"
              class="modal-entry-note"
            >
              {{ invio.notes || invio.noteAlimentazione || invio.noteAllenamento }}
            </p>
          </div>
        </li>
      </ul>

      <div v-else class="modal-state muted">Nessun invio registrato per questo utente.</div>
    </div>
  </div>
  </div>
</template>
  


<script>
import { ref, reactive, onMounted, computed, watch } from 'vue';
import AdminPasswordReset from './AdminPasswordReset.vue';
import UserExpiringNote from '@/components/module/UserExpiringNote.vue';
import { useRoute } from 'vue-router';
import { getAuth } from 'firebase/auth';
import {
  getFirestore,
  doc,
  updateDoc,
  addDoc,
  collection,
  serverTimestamp,
  Timestamp,
  getDoc,
  query,
  where,
  orderBy,
  getDocs,
} from "firebase/firestore";
import { saveDailySend } from '@/lib/dailySend';
import { isValidUserPhone, normalizeUserPhone } from '@/lib/userPhone';
import {
  OPERATIONAL_HOLD_REASONS,
  getOperationalHoldReasonLabel,
  getOperationalHoldSummary,
  isOperationalHoldActive,
  normalizeOperationalHold,
} from '@/lib/operationalHold';

const MONTH_OPTIONS = [
  { value: '01', label: '01 - Gennaio' },
  { value: '02', label: '02 - Febbraio' },
  { value: '03', label: '03 - Marzo' },
  { value: '04', label: '04 - Aprile' },
  { value: '05', label: '05 - Maggio' },
  { value: '06', label: '06 - Giugno' },
  { value: '07', label: '07 - Luglio' },
  { value: '08', label: '08 - Agosto' },
  { value: '09', label: '09 - Settembre' },
  { value: '10', label: '10 - Ottobre' },
  { value: '11', label: '11 - Novembre' },
  { value: '12', label: '12 - Dicembre' },
];

const DAY_OPTIONS = Array.from({ length: 31 }, (_, idx) => {
  const value = String(idx + 1).padStart(2, '0');
  return { value, label: value };
});

const buildYearOptions = () => {
  const now = new Date();
  const maxYear = now.getFullYear() - 10;
  const minYear = now.getFullYear() - 90;
  const list = [];
  for (let year = maxYear; year >= minYear; year -= 1) {
    list.push(String(year));
  }
  return list;
};

const YEAR_OPTIONS = buildYearOptions();

const VIDEO_CALL_LABELS = {
  chiamata: 'Chiamata',
  videocallfatta: 'Videocall Fatta',
  nonrisponde: 'Non risponde',
  ciricontatta: 'Ci ricontatta',
  inviatamail: 'Inviata mail',
  inviatoticket: 'Inviato Ticket',
  secondacall: 'Seconda call',
  rinnovo: 'Rinnovo',
};

const ROW_COLOR_LABELS = {
  red: 'Rosso - no consegna',
  blue: 'Blu - video call da fare',
  yellow: 'Giallo - Uomo',
  protocollo: 'PROTOCOLLO 25',
  green: 'Verde - solo allenamento',
  pink: 'Rosa - solo dieta',
};

const ROW_COLOR_BACKGROUNDS = {
  red: 'rgba(255, 0, 0, 0.16)',
  blue: 'rgba(0, 82, 204, 0.16)',
  yellow: 'rgba(255, 200, 0, 0.18)',
  protocollo: 'rgba(255, 88, 0, 0.18)',
  green: 'rgba(0, 168, 84, 0.16)',
  pink: 'rgba(255, 160, 190, 0.2)',
};

const ROW_COLOR_BORDERS = {
  red: '#c62828',
  blue: '#1d4ed8',
  yellow: '#ca8a04',
  protocollo: '#ea580c',
  green: '#16a34a',
  pink: '#db2777',
};

export default {
  name: "UserDetails",
  components: { AdminPasswordReset, UserExpiringNote },
  props: {
    userId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const userDetails = ref({
      nascita: '', // per la data di nascita
      dataAcquistoCsen: '',
      linkdrop: '', // Assicurati che questo campo esista nel tuo database Firebase per gli utenti
      noteAlimentazione: '',  // Nuovo campo
      noteAllenamento: '',
      noteCheck: '',
      assignedEmail: '',
      dafarein: '',
      influencer: false,
    });
    const birthdateParts = reactive({ day: '', month: '', year: '' });
    const userId = ref(null);
    const route = useRoute();
    const passwordResetUserId = computed(() => props.userId || route.params.userId || '');
    const db = getFirestore();
    const isSaving = ref(false); // Variabile per gestire lo stato del bottone
    const influencerSaving = ref(false);
    const showInviiModal = ref(false);
    const inviiLoading = ref(false);
    const inviiError = ref('');
    const inviiList = ref([]);
    const operationalHoldSaving = ref(false);
    const operationalHoldFeedback = ref('');
    const operationalHoldForm = reactive({
      reason: 'payment_default',
      note: '',
      hideFromOperationalLists: true,
      suppressNotifications: true,
      stopManualInstallments: false,
    });
    const fuscoData = reactive({
      nomeCognome: '',
      note: '',
      dataNascita: '',
      updatedAt: null,
    });
    const fuscoLoading = ref(false);
    const fuscoError = ref('');
    const csenOrderDate = ref(null);

    const parseBirthdateParts = (value) => {
      if (!value) return null;
      const str = String(value).trim();
      const iso = str.match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
      if (iso) return { year: iso[1], month: iso[2], day: iso[3] };
      const dmy = str.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
      if (dmy) return { year: dmy[3], month: dmy[2], day: dmy[1] };
      const parsed = new Date(str);
      if (Number.isNaN(parsed.getTime())) return null;
      return {
        year: String(parsed.getUTCFullYear()),
        month: String(parsed.getUTCMonth() + 1).padStart(2, '0'),
        day: String(parsed.getUTCDate()).padStart(2, '0'),
      };
    };

    const syncBirthdatePartsFromValue = (value) => {
      const parsed = parseBirthdateParts(value);
      birthdateParts.year = parsed?.year || '';
      birthdateParts.month = parsed?.month || '';
      birthdateParts.day = parsed?.day || '';
    };

    const buildBirthdateValue = () => {
      if (birthdateParts.year && birthdateParts.month && birthdateParts.day) {
        return `${birthdateParts.year}-${birthdateParts.month}-${birthdateParts.day}`;
      }
      return '';
    };

    const toDateSafe = (value) => {
      if (!value) return null;
      if (typeof value.toDate === 'function') {
        const d = value.toDate();
        return Number.isNaN(d.getTime()) ? null : d;
      }
      const d = value instanceof Date ? value : new Date(value);
      return Number.isNaN(d.getTime()) ? null : d;
    };

    const parseDateOnly = (value) => {
      if (!value) return null;
      if (typeof value?.toDate === 'function') {
        const d = value.toDate();
        if (Number.isNaN(d.getTime())) return null;
        return new Date(d.getFullYear(), d.getMonth(), d.getDate());
      }
      if (value instanceof Date) {
        return Number.isNaN(value.getTime())
          ? null
          : new Date(value.getFullYear(), value.getMonth(), value.getDate());
      }
      const str = String(value).trim();
      if (!str) return null;
      const base = str.split(/[T ]/)[0];
      const ymd = base.match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
      if (ymd) {
        const parsed = new Date(Number(ymd[1]), Number(ymd[2]) - 1, Number(ymd[3]));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
      const dmy = base.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
      if (dmy) {
        const parsed = new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
      const normalized = str.includes('T') ? str : str.replace(' ', 'T');
      const parsed = new Date(normalized);
      if (Number.isNaN(parsed.getTime())) return null;
      return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
    };

    const formatDateInput = (value) => {
      const date = parseDateOnly(value);
      if (!date) return '';
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    const addMonthsLocal = (date, months) => {
      if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
      const out = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      out.setMonth(out.getMonth() + Number(months || 0));
      return out;
    };

    const CSEN_PRODUCT_KEY = '1annocsen';
    const normalizeCsenKey = (value) =>
      String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const isCsenProduct = (product = {}) => {
      const skuKey = normalizeCsenKey(product?.sku);
      const nameKey = normalizeCsenKey(product?.name || product?.title || product?.productName);
      return skuKey === CSEN_PRODUCT_KEY || nameKey === CSEN_PRODUCT_KEY;
    };

    const parseOrderDate = (order = {}) => {
      const value = order?.orderDate;
      if (!value) return null;
      if (typeof value?.toDate === 'function') {
        const date = value.toDate();
        if (date instanceof Date && !Number.isNaN(date.getTime())) return date;
      }
      const str = String(value).trim();
      if (!str) return null;
      const normalized = str.includes('T') ? str : str.replace(' ', 'T');
      const parsed = new Date(normalized);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    const normalizeOrderStatus = (value) => String(value || '').trim().toLowerCase();
    const isInvalidOrderStatus = (statusRaw) => {
      const status = normalizeOrderStatus(statusRaw);
      if (!status) return false;
      return (
        status.includes('rimborsato') ||
        status.includes('cancellato') ||
        status.includes('scaduto') ||
        status.includes('refunded') ||
        status.includes('void') ||
        status.includes('expired') ||
        status.includes('refused')
      );
    };
    const isPaidOrder = (order = {}) => {
      const status = normalizeOrderStatus(order.status);
      const paymentStatus = normalizeOrderStatus(order.paymentStatus);
      if (isInvalidOrderStatus(status) || isInvalidOrderStatus(paymentStatus)) return false;
      return status === 'pagato' || status === 'completed' || paymentStatus === 'completed';
    };

    const calculateAgeFromBirthdate = (value) => {
      if (!value) return null;
      let normalized = String(value).trim();
      const match = normalized.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
      if (match) {
        const [, d, m, y] = match;
        normalized = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      }
      const birthDate = toDateSafe(normalized);
      if (!birthDate) return null;
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age -= 1;
      }
      return age >= 0 ? age : null;
    };

    const resetFuscoData = () => {
      fuscoData.nomeCognome = '';
      fuscoData.note = '';
      fuscoData.dataNascita = '';
      fuscoData.updatedAt = null;
    };

    const fetchFuscoQuestionarioData = async () => {
      fuscoError.value = '';
      fuscoLoading.value = true;
      resetFuscoData();

      if (!userId.value) {
        fuscoLoading.value = false;
        return;
      }

      try {
        const snapshot = await getDocs(query(collection(db, 'questionari'), where('uid', '==', userId.value)));
        let latest = null;

        snapshot.forEach((docSnap) => {
          const data = docSnap.data() || {};
          const answers = data.answers || {};
          const typeKey = String(
            data.type || data.templateKey || data.questionarioTemplateKey || ''
          ).toLowerCase();
          const hasFuscoSection = Boolean(
            answers.fuscoNomeCognome || answers.fuscoNote || answers.dataNascita
          );
          const matchesQuestionario =
            typeKey === 'user_programmi_questionario' || typeKey === 'questionario';
          if (!hasFuscoSection && !matchesQuestionario) return;

          const updatedAt =
            toDateSafe(data.updatedAt) ||
            toDateSafe(data.createdAt) ||
            (docSnap.updateTime?.toDate ? docSnap.updateTime.toDate() : null);

          if (!latest) {
            latest = { answers, updatedAt, hasFuscoSection };
            return;
          }

          if (latest.hasFuscoSection && !hasFuscoSection) return;
          if (!latest.hasFuscoSection && hasFuscoSection) {
            latest = { answers, updatedAt, hasFuscoSection };
            return;
          }

          if (updatedAt && (!latest.updatedAt || updatedAt > latest.updatedAt)) {
            latest = { answers, updatedAt, hasFuscoSection };
          }
        });

        if (latest) {
          fuscoData.nomeCognome = latest.answers.fuscoNomeCognome || '';
          fuscoData.note = latest.answers.fuscoNote || '';
          fuscoData.dataNascita = latest.answers.dataNascita || '';
          fuscoData.updatedAt = latest.updatedAt || null;
        }
      } catch (error) {
        console.error("Errore nel recuperare la sezione Giampaolo Fusco:", error);
        fuscoError.value = 'Impossibile recuperare i dati del questionario.';
      } finally {
        fuscoLoading.value = false;
      }
    };

    const fetchCsenPurchaseDate = async () => {
      csenOrderDate.value = null;

      const email = String(userDetails.value?.email || '').trim();
      if (!userId.value && !email) return;

      try {
        const ordersRef = collection(db, 'orders');
        const queries = [];
        if (userId.value) {
          queries.push(query(ordersRef, where('userUid', '==', userId.value)));
          queries.push(query(ordersRef, where('uid', '==', userId.value)));
        }
        if (email) {
          queries.push(query(ordersRef, where('userEmail', '==', email)));
        }

        const docsById = new Map();
        for (const q of queries) {
          const snap = await getDocs(q);
          snap.forEach((docSnap) => {
            if (!docsById.has(docSnap.id)) {
              docsById.set(docSnap.id, docSnap.data());
            }
          });
        }

        let latest = null;
        for (const order of docsById.values()) {
          if (!isPaidOrder(order)) continue;
          const products = Array.isArray(order?.products) ? order.products : [];
          if (!products.some(isCsenProduct)) continue;
          const date = parseOrderDate(order);
          if (!date) continue;
          if (!latest || date > latest) latest = date;
        }

        if (latest) {
          csenOrderDate.value = latest;
        }
      } catch (error) {
        console.error('Errore nel recupero ordine CSEN:', error);
      }
    };

    const fuscoAgeLabel = computed(() => {
      const age = calculateAgeFromBirthdate(fuscoData.dataNascita);
      return age != null ? `${age} anni` : '';
    });

    const fuscoHasData = computed(() => {
      return Boolean(fuscoData.nomeCognome || fuscoData.note || fuscoData.dataNascita);
    });



    const resolveUserId = () => props.userId || route.params.userId || null;

    const getOperatorUid = () => getAuth().currentUser?.uid || null;

    const syncOperationalHoldForm = (data = {}) => {
      const hold = normalizeOperationalHold(data);
      operationalHoldForm.reason = hold.reason || 'payment_default';
      operationalHoldForm.note = hold.note || '';
      operationalHoldForm.hideFromOperationalLists = hold.active
        ? hold.hideFromOperationalLists
        : true;
      operationalHoldForm.suppressNotifications = hold.active
        ? hold.suppressNotifications
        : true;
      operationalHoldForm.stopManualInstallments = false;
    };

    const buildOperationalHoldPayload = (active) => {
      const previous = normalizeOperationalHold(userDetails.value || {});
      const nowIso = new Date().toISOString();
      const operatorUid = getOperatorUid();

      if (!active) {
        return {
          ...previous,
          active: false,
          hideFromOperationalLists: false,
          suppressNotifications: false,
          updatedAt: nowIso,
          updatedBy: operatorUid,
          clearedAt: nowIso,
          clearedBy: operatorUid,
        };
      }

      return {
        ...previous,
        active: true,
        reason: operationalHoldForm.reason || 'other',
        note: String(operationalHoldForm.note || '').trim(),
        hideFromOperationalLists: operationalHoldForm.hideFromOperationalLists !== false,
        suppressNotifications: operationalHoldForm.suppressNotifications !== false,
        createdAt: previous.createdAt || nowIso,
        createdBy: previous.createdBy || operatorUid,
        updatedAt: nowIso,
        updatedBy: operatorUid,
        clearedAt: null,
        clearedBy: null,
      };
    };

    const collectOrderDocsForUser = async () => {
      if (!userId.value && !userDetails.value?.email) return [];

      const ordersRef = collection(db, 'orders');
      const selectors = [];
      const uid = String(userId.value || '').trim();
      const email = String(userDetails.value?.email || '').trim();

      if (uid) {
        selectors.push(['userUid', uid], ['uid', uid], ['userId', uid]);
      }
      if (email) {
        selectors.push(['userEmail', email], ['customerEmail', email], ['email', email]);
      }

      const docsById = new Map();
      for (const [field, value] of selectors) {
        try {
          const snap = await getDocs(query(ordersRef, where(field, '==', value)));
          snap.forEach((docSnap) => {
            if (docsById.has(docSnap.id)) return;
            const data = docSnap.data() || {};
            const plan = Array.isArray(data.manualInstallments) ? data.manualInstallments : [];
            if (!plan.length) return;
            docsById.set(docSnap.id, docSnap.ref);
          });
        } catch (error) {
          console.warn(`Errore ricerca ordini rate manuali per ${field}:`, error);
        }
      }

      return Array.from(docsById.entries()).map(([id, ref]) => ({ id, ref }));
    };

    const setManualInstallmentsStopForUser = async (nextStop) => {
      const orderDocs = await collectOrderDocsForUser();
      if (!orderDocs.length) return 0;

      const nowIso = new Date().toISOString();
      await Promise.all(orderDocs.map(({ ref }) =>
        updateDoc(ref, {
          manualInstallmentsStop: nextStop,
          manualInstallmentsStopReason: nextStop ? 'operational_hold' : null,
          manualInstallmentsStopUpdatedAt: nowIso,
          manualInstallmentsStopUpdatedBy: getOperatorUid(),
          updatedAt: nowIso,
        })
      ));

      return orderDocs.length;
    };

    const persistOperationalHold = async (active) => {
      if (!userId.value) {
        alert('ID utente mancante.');
        return;
      }

      operationalHoldSaving.value = true;
      operationalHoldFeedback.value = '';

      try {
        const payload = buildOperationalHoldPayload(active);
        const userRef = doc(db, 'users', userId.value);
        await updateDoc(userRef, {
          operationalHold: payload,
          updatedAt: new Date().toISOString(),
        });

        userDetails.value = {
          ...(userDetails.value || {}),
          operationalHold: payload,
        };

        if (active && operationalHoldForm.stopManualInstallments) {
          const updatedOrders = await setManualInstallmentsStopForUser(true);
          operationalHoldFeedback.value = updatedOrders
            ? `Sospensione salvata. Ordini rate in STOP: ${updatedOrders}.`
            : 'Sospensione salvata. Nessuna rata manuale collegata trovata.';
        } else {
          operationalHoldFeedback.value = active
            ? 'Sospensione operativa salvata.'
            : 'Operatività riattivata.';
        }

        syncOperationalHoldForm(userDetails.value);
      } catch (error) {
        console.error('Errore nel salvataggio della sospensione operativa:', error);
        alert('Errore nel salvataggio della sospensione operativa.');
      } finally {
        operationalHoldSaving.value = false;
      }
    };

    const saveOperationalHold = async () => {
      const reasonLabel = getOperationalHoldReasonLabel(operationalHoldForm.reason);
      const confirmMessage = isOperationalHoldActive(userDetails.value || {})
        ? `Aggiornare la sospensione operativa (${reasonLabel})?`
        : `Sospendere operativamente questo utente (${reasonLabel})?`;
      if (!window.confirm(confirmMessage)) return;
      await persistOperationalHold(true);
    };

    const clearOperationalHold = async () => {
      if (!window.confirm('Riattivare questo utente nei flussi operativi?')) return;
      await persistOperationalHold(false);
    };

    const fetchUserDetails = async () => {
      userId.value = resolveUserId();
      if (!userId.value) {
        console.error("Nessun ID utente fornito");
        return;
      }

      try {
        const docRef = doc(db, "users", userId.value);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          let userData = docSnap.data();
          userData.nascita = userData.nascita || '';
          userData.dataAcquistoCsen = userData.dataAcquistoCsen || '';
          userData.phone = userData.phone || userData.telefono || '';
          userData.influencer = userData.influencer === true || userData.vip === true;
          userDetails.value = userData;
          syncBirthdatePartsFromValue(userData.nascita);
          operationalHoldFeedback.value = '';
          syncOperationalHoldForm(userData);
        } else {
          console.log("Nessun utente trovato!");
        }
      } catch (error) {
        console.error("Errore nel recuperare i dettagli dell'utente:", error);
      }

      await fetchCsenPurchaseDate();
      await fetchFuscoQuestionarioData();
    };




  const handleSave = async () => {
    const confirmSave = window.confirm("Sei sicuro di voler procedere all'invio?");
    if (!confirmSave) return;

    isSaving.value = true;
    try {
      const targetPercorso = await findNextPercorsoForDailySend();
      await saveToInviidiGiornata(targetPercorso);
      await fetchUserDetails();
      const marked = await markEligibleQuestionarioAsSent(targetPercorso);
      alert(
        marked
          ? 'Invio utente registrato e questionario/check segnato come inviato.'
          : 'Invio utente registrato.'
      );
    } catch (error) {
      console.error("Errore durante il salvataggio:", error);
      alert("Errore durante il salvataggio dei dati.");
    } finally {
      isSaving.value = false;
    }
  };




const sendCheck = async () => {
  // conferma prima di inviare
  const confirmSend = window.confirm("Sei sicuro di voler procedere all'invio?");
  if (!confirmSend) return;

  if (!userId.value) {
    alert("ID utente mancante.");
    return;
  }

  // Calcolo di dataConsegna: +3 giorni lavorativi
  const now = new Date();
  let giorniAggiunti = 0;
  let dataConsegna = new Date(now);
  while (giorniAggiunti < 3) {
    dataConsegna.setDate(dataConsegna.getDate() + 1);
    const wd = dataConsegna.getDay();
    if (wd !== 0 && wd !== 6) giorniAggiunti++;
  }

  try {
    await addDoc(collection(db, "checkdafare"), {
      uid:           userId.value,
      surname:       userDetails.value.surname || "",
      studio:        userDetails.value.studio || "",
      notedelcheck:  userDetails.value.noteCheck || "",
      notes:         userDetails.value.notes || "",
      assignedEmail: userDetails.value.assignedEmail || "",
        dafarein:      userDetails.value.dafarein || "",
      fatto:         "da fare",
      createdAt:     serverTimestamp(),
      dataConsegna:  Timestamp.fromDate(dataConsegna)
    });

    alert("Check inviato con successo!");
    // reset dei campi
    userDetails.value.noteCheck     = "";
    userDetails.value.assignedEmail = "";
    userDetails.value.dafarein = "";
  } catch (error) {
    console.error("Errore invio check:", error);
    alert("Errore durante l'invio del check.");
  }
};








const saveToInviidiGiornata = async (percorsoContext = null) => {
  if (!userDetails.value || !userId.value) {
    alert("Dettagli utente o ID non disponibili per il salvataggio.");
    console.error("Missing user details or user ID");
    return;
  }

  try {
    await saveDailySend({
      userId: userId.value,
      userData: { ...(userDetails.value || {}) },
      percorsoId: percorsoContext?.percorsoId || null,
      percorsoTitle: percorsoContext?.percorsoTitle || null,
      percorsoSequenceIndex: percorsoContext?.sequenceIndex ?? null,
      percorsoSequenceTotal: percorsoContext?.sequenceTotal ?? null,
    });
  } catch (error) {
    console.error("Errore durante il salvataggio dei dati:", error);
    throw error;
  }
};

const stepKeyFromName = (name = '') => {
  const n = (name || '').toLowerCase();
  if (n.includes('questionario')) return 'questionario';
  if (n.includes('check') || n.includes('scadenza')) return 'check_finale';
  return '';
};

const isStepEligibleForDailySend = (step) => {
  const key = stepKeyFromName(step?.name || '');
  if (key !== 'questionario' && key !== 'check_finale') return false;
  if (step?.adminDailySent) return false;
  return (step?.adminStatus || '').toLowerCase() === 'approved';
};

const normalizeSequenceValue = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
};

const buildPercorsoContext = (percorsoSnap, data, stepIndex) => {
  if (!percorsoSnap) return null;
  const rawTitle = (data.title || data.productName || '').trim();
  return {
    percorsoId: percorsoSnap.id,
    percorsoTitle: rawTitle || null,
    sequenceIndex: normalizeSequenceValue(data.sequenceIndex),
    sequenceTotal: normalizeSequenceValue(data.sequenceTotal),
    stepIndex,
  };
};

const findNextPercorsoForDailySend = async () => {
  if (!userId.value) return null;
  try {
    const percorsiRef = collection(db, 'percorsi');
    const percorsiSnap = await getDocs(query(percorsiRef, where('uid', '==', userId.value)));

    for (const percorsoSnap of percorsiSnap.docs) {
      const data = percorsoSnap.data() || {};
      const steps = Array.isArray(data.steps) ? [...data.steps] : [];
      const targetIndex = steps.findIndex(isStepEligibleForDailySend);
      if (targetIndex < 0) continue;
      return buildPercorsoContext(percorsoSnap, data, targetIndex);
    }
  } catch (error) {
    console.error('Errore durante la ricerca del percorso per l’invio di giornata:', error);
  }
  return null;
};

const markEligibleQuestionarioAsSent = async (targetContext = null) => {
  if (!userId.value) return false;
  try {
    const context = targetContext || (await findNextPercorsoForDailySend());
    if (!context || !context.percorsoId || !Number.isInteger(context.stepIndex)) {
      return false;
    }

    const percorsoRef = doc(db, 'percorsi', context.percorsoId);
    const percorsoSnap = await getDoc(percorsoRef);
    if (!percorsoSnap.exists()) return false;

    const data = percorsoSnap.data() || {};
    const steps = Array.isArray(data.steps) ? [...data.steps] : [];
    if (!steps[context.stepIndex]) return false;

    const updatedSteps = [...steps];
    const prev = updatedSteps[context.stepIndex] || {};
    const iso = new Date().toISOString();
    updatedSteps[context.stepIndex] = {
      ...prev,
      adminDailySent: true,
      adminDailySentAt: iso,
      adminUpdatedAt: iso,
    };

    await updateDoc(percorsoRef, { steps: updatedSteps });
    return true;
  } catch (error) {
    console.error('Errore durante la ricerca del questionario/check da marcare inviato:', error);
  }
  return false;
};






const formatDate = (timestamp) => {
  const date = toDateSafe(timestamp);
  if (!date) return '';

  // Formattazione dello stile italiano
  const optionsDate = { day: 'numeric', month: 'long', year: 'numeric' };
  const optionsTime = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
  const formattedDate = date.toLocaleDateString('it-IT', optionsDate);
  const formattedTime = date.toLocaleTimeString('it-IT', optionsTime);

  return `${formattedDate} alle ore ${formattedTime}`;
};

const formatDateOnly = (timestamp) => {
  const date = toDateSafe(timestamp);
  if (!date) return '';

  const optionsDate = { day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('it-IT', optionsDate);
};

const getLatestAlimentazione = (invio) => {
  const list = Array.isArray(invio?.alimentazioni) ? invio.alimentazioni : [];
  if (!list.length) return null;

  let latest = list[0];
  let latestTime = toDateSafe(latest?.dataCreazione)?.getTime();
  if (!Number.isFinite(latestTime)) {
    latestTime = Number.NEGATIVE_INFINITY;
  }

  list.slice(1).forEach((item) => {
    const time = toDateSafe(item?.dataCreazione)?.getTime();
    if (Number.isFinite(time) && time >= latestTime) {
      latest = item;
      latestTime = time;
    }
  });

  return latest;
};

const getVideocallLabel = (invio) => {
  const latest = getLatestAlimentazione(invio);
  const raw = String(latest?.videocall || '').trim();
  if (!raw) return '';
  return VIDEO_CALL_LABELS[raw] || raw;
};

const getRowColorLabel = (invio) => {
  const raw = String(invio?.rowColor || '').trim();
  if (!raw) return 'Nessun colore';
  return ROW_COLOR_LABELS[raw] || raw;
};

const hasRowColor = (invio) => {
  const raw = String(invio?.rowColor || '').trim();
  return !!ROW_COLOR_BACKGROUNDS[raw];
};

const getRowColorStyle = (invio) => {
  const raw = String(invio?.rowColor || '').trim();
  const backgroundColor = ROW_COLOR_BACKGROUNDS[raw];
  if (!backgroundColor) return null;
  return {
    backgroundColor,
    borderLeftColor: ROW_COLOR_BORDERS[raw] || 'transparent',
  };
};








const fetchInviiDiGiornata = async () => {
  inviiError.value = '';
  inviiList.value = [];

  if (!userId.value) {
    inviiError.value = 'ID utente non disponibile.';
    return;
  }

  inviiLoading.value = true;
  try {
    const baseRef = collection(db, 'inviidigiornata');
    let snapshot;
    try {
      const orderedQuery = query(baseRef, where('uid', '==', userId.value), orderBy('createdAt', 'desc'));
      snapshot = await getDocs(orderedQuery);
    } catch (error) {
      if (error?.code === 'failed-precondition') {
        const fallbackQuery = query(baseRef, where('uid', '==', userId.value));
        snapshot = await getDocs(fallbackQuery);
      } else {
        throw error;
      }
    }

    inviiList.value = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
  } catch (error) {
    console.error('Errore recuperando gli invii di giornata:', error);
    inviiError.value = 'Impossibile recuperare gli invii di giornata.';
  } finally {
    inviiLoading.value = false;
  }
};

const openInviiModal = () => {
  showInviiModal.value = true;
  fetchInviiDiGiornata();
};

const closeInviiModal = () => {
  showInviiModal.value = false;
};

    watch(
      () => [birthdateParts.day, birthdateParts.month, birthdateParts.year],
      () => {
        if (!userDetails.value) return;
        userDetails.value.nascita = buildBirthdateValue();
      },
      { immediate: true }
    );

    // Computed property per calcolare lo stato della privacy
    const privacyStatus = computed(() => {
      if (userDetails.value.privacyAccettata === true) {
        return 'Accettata';
      } else {
        return 'Non Accettata';
      }
    });

    const operationalHoldActive = computed(() =>
      isOperationalHoldActive(userDetails.value || {})
    );

    const operationalHoldSummary = computed(() =>
      getOperationalHoldSummary(userDetails.value || {}) || 'Sospensione operativa attiva'
    );

    const operationalHoldMeta = computed(() => {
      const hold = normalizeOperationalHold(userDetails.value || {});
      const date = hold.updatedAt || hold.createdAt || hold.clearedAt;
      if (!date) return '';
      const label = hold.active ? 'Aggiornata' : 'Riattivata';
      return `${label} ${formatDateOnly(date)}`;
    });

    const csenEffectiveDate = computed(() =>
      parseDateOnly(csenOrderDate.value || userDetails.value?.dataAcquistoCsen)
    );

    const csenHasOrderDate = computed(() => !!csenOrderDate.value);

    const csenPurchaseInput = computed({
      get: () => formatDateInput(csenEffectiveDate.value),
      set: (value) => {
        if (!userDetails.value) return;
        if (csenHasOrderDate.value) return;
        userDetails.value.dataAcquistoCsen = value || '';
      },
    });

    const csenInfo = computed(() => {
      const purchaseDate = csenEffectiveDate.value;
      if (!purchaseDate) {
        return {
          status: 'missing',
          label: 'Data non impostata',
          icon: 'help_outline',
          className: 'csen-status--missing',
        };
      }

      const expiryDate = addMonthsLocal(purchaseDate, 12);
      const warningStart = addMonthsLocal(expiryDate, -1);
      if (!expiryDate || !warningStart) {
        return {
          status: 'missing',
          label: 'Data non valida',
          icon: 'help_outline',
          className: 'csen-status--missing',
        };
      }

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      let status = 'valid';
      if (today > expiryDate) status = 'expired';
      else if (today >= warningStart) status = 'warning';

      const labels = {
        valid: 'Valido',
        warning: 'In scadenza',
        expired: 'Scaduto',
      };
      const icons = {
        valid: 'check_circle',
        warning: 'error',
        expired: 'cancel',
      };

      return {
        status,
        label: labels[status],
        icon: icons[status],
        className: `csen-status--${status}`,
      };
    });



    const updateInfluencerStatus = async (nextValue) => {
      if (!userId.value || !userDetails.value) {
        return;
      }

      const normalizedValue = nextValue === true;
      const previousValue = !normalizedValue;
      userDetails.value.influencer = normalizedValue;
      influencerSaving.value = true;

      try {
        await updateDoc(doc(db, "users", userId.value), {
          influencer: normalizedValue,
        });
      } catch (error) {
        userDetails.value.influencer = previousValue;
        console.error("Errore nel salvataggio del flag Influencer:", error);
        alert("Errore nel salvataggio del flag Influencer.");
      } finally {
        influencerSaving.value = false;
      }
    };

    const updateUserDetails = async () => {
      if (!userDetails.value) {
        console.error("Nessun dettaglio utente da aggiornare");
        return;
      }

      try {
        const normalizedPhone = normalizeUserPhone(userDetails.value.phone);
        if (normalizedPhone && !isValidUserPhone(normalizedPhone)) {
          alert("Inserisci un numero di telefono valido.");
          return;
        }

        const docRef = doc(db, "users", userId.value);
        const detailsToSave = {
          ...userDetails.value,
          phone: normalizedPhone,
        };
        delete detailsToSave.credito;
        // The shared editor owns this field. A stale profile save must never
        // replace a newer note or its timestamp from another page/operator.
        delete detailsToSave.expiringListNote;
        delete detailsToSave.updatedAt;
        await updateDoc(docRef, {
          ...detailsToSave,
          influencer: userDetails.value.influencer === true,
        });
        alert("Dettagli utente aggiornati con successo!"); // Alert classico
      } catch (error) {
        console.error("Errore nell'aggiornamento dei dettagli dell'utente:", error);
        alert("Errore nell'aggiornamento dei dettagli dell'utente.");
      }
    };

    const openDropboxLink = () => {
      const link = userDetails.value.linkdrop;
      if (link) {
        window.open(link, '_blank');
      } else {
        alert('Il link Dropbox non è impostato.');
      }
    };

    // Carica i dettagli dell'utente all'avvio
    onMounted(fetchUserDetails);

    return { 
      userDetails, 
      passwordResetUserId,
      updateUserDetails, 
      fetchUserDetails,  
      openDropboxLink,
      privacyStatus,
      csenPurchaseInput,
      csenInfo,
      csenHasOrderDate,
      saveToInviidiGiornata,
      formatDate,
      formatDateOnly,
      getVideocallLabel,
      getRowColorLabel,
      getRowColorStyle,
      hasRowColor,
      handleSave,
      sendCheck,
      isSaving,
      influencerSaving,
      showInviiModal,
      inviiLoading,
      inviiError,
      inviiList,
      openInviiModal,
      closeInviiModal,
      fuscoData,
      fuscoLoading,
      fuscoError,
      fuscoAgeLabel,
      fuscoHasData,
      updateInfluencerStatus,
      birthdateParts,
      DAY_OPTIONS,
      MONTH_OPTIONS,
      YEAR_OPTIONS,
      operationalHoldReasons: OPERATIONAL_HOLD_REASONS,
      operationalHoldForm,
      operationalHoldSaving,
      operationalHoldFeedback,
      operationalHoldActive,
      operationalHoldSummary,
      operationalHoldMeta,
      saveOperationalHold,
      clearOperationalHold,
    };
  },
};
</script>



  
  <style scoped>

.birthdate-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(90px, 1fr));
  gap: 8px;
}

.birthdate-group .user-input {
  width: 100%;
}

.input-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.status-icon .material-icons {
  font-size: 20px;
}

.status-text {
  font-size: 12px;
  font-weight: 600;
}

.csen-status--valid {
  color: #2e7d32;
}

.csen-status--warning {
  color: #d97706;
}

.csen-status--expired {
  color: #c62828;
}

.csen-status--missing {
  color: #6b7280;
}

.influencer-toggle-row {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
  padding: 10px 12px;
  border: 1px solid #d6e2f5;
  border-radius: 12px;
  background: #f8fbff;
}

.influencer-toggle-row--active {
  border-color: #d4af37;
  background: linear-gradient(135deg, #fff8db 0%, #fff2bd 100%);
}

.influencer-toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}

.influencer-toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.influencer-toggle__slider {
  position: relative;
  width: 46px;
  height: 26px;
  border-radius: 999px;
  background: #cbd5e1;
  transition: background-color 0.2s ease;
}

.influencer-toggle__slider::after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.28);
  transition: transform 0.2s ease;
}

.influencer-toggle input:checked + .influencer-toggle__slider {
  background: #d4af37;
}

.influencer-toggle input:checked + .influencer-toggle__slider::after {
  transform: translateX(20px);
}

.influencer-toggle input:focus-visible + .influencer-toggle__slider {
  outline: 2px solid rgba(29, 78, 216, 0.35);
  outline-offset: 2px;
}

.influencer-toggle__text {
  font-weight: 600;
  color: #1f2937;
}

.influencer-toggle__saving {
  font-size: 0.85rem;
  color: #6b7280;
}

.operational-hold-card {
  --operational-hold-control-height: 42px;
  --operational-hold-label-height: 17px;
  border: 1px solid #d7e3f4;
  border-radius: 8px;
  padding: 12px 14px;
  background: #f9fbff;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.operational-hold-card--active {
  border-color: #f6c56d;
  background: #fffaf0;
}

.operational-hold-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.operational-hold-card__title {
  display: block;
  margin: 0 0 2px;
  font-weight: 700;
  color: #111827;
  font-size: 0.95rem;
  line-height: 1.2;
}

.operational-hold-card__subtitle,
.operational-hold-card__meta {
  margin: 0;
  color: #4b5563;
  font-size: 0.82rem;
  line-height: 1.25;
}

.operational-hold-card__meta {
  margin-top: 2px;
  color: #6b7280;
}

.operational-hold-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 9px;
  border-radius: 999px;
  background: #dcfce7;
  color: #166534;
  font-weight: 700;
  font-size: 0.76rem;
  line-height: 1;
  white-space: nowrap;
}

.operational-hold-badge--active {
  background: #fee2e2;
  color: #991b1b;
}

.operational-hold-grid {
  display: grid;
  grid-template-columns: minmax(260px, 360px) minmax(420px, 1fr);
  column-gap: 14px;
  row-gap: 8px;
  align-items: start;
}

.operational-hold-field {
  display: grid;
  grid-template-rows: var(--operational-hold-label-height) var(--operational-hold-control-height);
  gap: 3px;
  min-width: 0;
}

.operational-hold-field label {
  display: flex;
  align-items: center;
  margin: 0;
  color: #4b5563;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
}

.operational-hold-card .user-input,
.operational-hold-card .user-textarea {
  box-sizing: border-box !important;
  display: block !important;
  width: 100% !important;
  height: var(--operational-hold-control-height) !important;
  min-height: var(--operational-hold-control-height) !important;
  max-height: var(--operational-hold-control-height) !important;
  margin: 0 !important;
  padding: 0 12px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  background-color: #ffffff !important;
  color: #111827 !important;
  font-size: 0.9rem !important;
  line-height: var(--operational-hold-control-height) !important;
  box-shadow: none !important;
  resize: none !important;
}

.operational-hold-card select.operational-hold-select {
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  margin-right: 0 !important;
  vertical-align: top !important;
}

.operational-hold-card textarea.operational-hold-note {
  overflow: hidden !important;
  vertical-align: top !important;
}

.operational-hold-options {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
}

.operational-hold-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 22px;
  font-weight: 600;
  color: #374151;
  font-size: 0.82rem;
  line-height: 1.2;
}

.operational-hold-check input {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  margin: 0;
  accent-color: #2563eb;
}

.operational-hold-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.operational-hold-button {
  min-height: 36px;
  padding: 8px 14px !important;
  border-radius: 8px !important;
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.2;
  margin-left: 0 !important;
  margin-bottom: 0 !important;
}

.operational-hold-button--restore {
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  color: #111827;
}

.operational-hold-feedback {
  color: #4b5563;
  font-size: 0.82rem;
  font-weight: 600;
}

@media (max-width: 720px) {
  .operational-hold-card {
    padding: 12px;
  }

  .operational-hold-card__header {
    align-items: flex-start;
  }

  .operational-hold-grid {
    grid-template-columns: 1fr;
  }

  .operational-hold-actions {
    align-items: stretch;
  }

  .operational-hold-button {
    width: 100%;
  }
}


.flex-row {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.half-width {
  flex: 1;
  min-width: 200px;
}

.fusco-card {
  border: 1px solid #ffce99;
  border-radius: 12px;
  padding: 12px 14px;
  background: #fff2e4;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.fusco-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.fusco-card__eyebrow {
  margin: 0 0 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  font-size: 0.82rem;
}

.fusco-card__title {
  margin: 0;
  font-size: 1.05rem;
}

.fusco-card__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}

.fusco-field {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 12px;
}

.fusco-field--full {
  grid-column: 1 / -1;
}

.fusco-label {
  display: block;
  color: #6b7280;
  font-size: 0.85rem;
  font-weight: 600;
}

.fusco-value {
  margin: 4px 0 0;
  color: #111827;
}

.fusco-status {
  color: #4b5563;
  font-size: 0.9rem;
}

.fusco-state {
  color: #6b7280;
  font-size: 0.92rem;
}

.fusco-state--error {
  color: #b91c1c;
}



.button-container {
  margin-bottom: 77px;
}



.button-blu {
  padding: 20px 20px;
  background-color: #007bff; /* Blu primario */
  color: white;
  border: none;
  border-radius: 13px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-left: 20px;
}

.button-blu:hover {
  background-color: #0056b3; /* Blu più scuro al passaggio */
}


.green-background {
  background-color: rgba(0, 191, 0, 0.537);
}

.orange-background {
  background-color: rgba(255, 166, 0, 0.492);
}

.red-background {
  background-color: rgba(210, 0, 0, 0.497);
}

.button-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.button-inline-group {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 77px;
}

.button-inline-group .button-container {
  margin-bottom: 0;
}

.icon-button {
  background: transparent;
  border: 1px solid #d6e2f5;
  color: #2163d6;
  border-radius: 999px;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  font-size: 1rem;
  padding: 0;
}

.icon-button .icon-compact {
  width: 18px;
  height: 18px;
}

.icon-button:hover {
  background-color: rgba(33, 99, 214, 0.06);
  box-shadow: 0 2px 6px rgba(33, 99, 214, 0.18);
}

.icon-button:focus {
  outline: 2px solid rgba(33, 99, 214, 0.4);
  outline-offset: 2px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}


.modal-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
  pointer-events: none;
}

.modal-backdrop::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.12);
  backdrop-filter: blur(1px);
  pointer-events: auto;
}

.modal {
  position: relative;
  pointer-events: auto;
  background: #ffffff;
  border-radius: 14px;
  width: min(340px, calc(100% - 32px));
  max-height: 40vh;
  padding: 18px 18px 16px;
  box-shadow: 0 24px 44px rgba(15, 23, 42, 0.22);
  display: flex;
  flex-direction: column;
}

.modal-header {
  position: relative;
  text-align: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4eaf2;
}

.modal-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #1f2937;
}

.modal-close {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  border: none;
  background: transparent;
  color: #9aa4b4;
  font-size: 1.05rem;
  cursor: pointer;
  line-height: 1;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  color: #111827;
}

.modal-close:focus {
  outline: 2px solid rgba(17, 24, 39, 0.3);
  outline-offset: 2px;
}

.modal-state {
  padding: 18px 4px;
  text-align: center;
  color: #475569;
  font-size: 0.9rem;
}

.modal-state.error {
  color: #b91c1c;
}

.modal-state.muted {
  color: #94a3b8;
}

.modal-list {
  list-style: none;
  margin: 16px 0 0;
  padding: 0;
  max-height: 52vh;
  overflow-y: auto;
}

.modal-entry {
  display: flex;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid #eef2f8;
}

.modal-entry:first-child {
  padding-top: 6px;
}

.modal-entry:last-child {
  border-bottom: none;
}

.modal-entry--colored {
  border-left: 4px solid transparent;
  border-radius: 12px;
  padding-left: 10px;
  padding-right: 10px;
}

.modal-entry-index {
  color: #2563eb;
  font-weight: 600;
  min-width: 28px;
}

.modal-entry-content {
  flex: 1;
  min-width: 0;
}

.modal-entry-date {
  margin: 0 0 6px;
  font-weight: 600;
  color: #111827;
}

.modal-entry-delivery,
.modal-entry-meta {
  margin: 0 0 6px;
  font-weight: 500;
  color: #475569;
}

.modal-entry-note {
  margin: 0;
  color: #4b5563;
  line-height: 1.45;
  word-break: break-word;
}


/* Size fields from the available profile width, including when the sidebar is open. */
.user-details-page,
.user-details-page .user-details-container,
.user-details-page form {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.user-details-page .titolo-card {
  margin: 0 0 18px;
  font-style: normal;
}

.user-details-page .titolo-card h1 {
  margin: 0;
  font-size: clamp(22px, 2.4vw, 28px);
  line-height: 1.25;
}

.user-details-page .user-details-container {
  container: anagrafica / inline-size;
}

.user-details-page .grid-container {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px 20px;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.user-details-page :is(.grid-item, .half-width, .birthdate-group, .input-status-row, .fusco-field) {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
}

.user-details-page .grid-container > :is(.grid-item, .half-width) {
  margin: 0;
}

.user-details-page .full-width {
  grid-column: 1 / -1;
  margin-bottom: 0;
}

.user-details-page :is(.grid-item, .half-width) > label {
  display: block;
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 600;
  color: #61666d;
  line-height: 18px;
  overflow-wrap: anywhere;
}

.user-details-page :is(.user-input, .user-textarea) {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  font-family: inherit;
  font-size: 14px;
}

.user-details-page .user-input {
  height: 44px;
  min-height: 44px;
}

.user-details-page .user-textarea {
  height: 160px;
  min-height: 120px;
  line-height: 1.5;
  resize: vertical;
}

.user-details-page .birthdate-group {
  grid-template-columns: minmax(0, .8fr) minmax(0, 1.4fr) minmax(0, 1fr);
  gap: 6px;
}

.user-details-page .birthdate-group select {
  padding-left: 8px;
  padding-right: 24px;
  background-position: right 6px center;
}

.user-details-page .input-status-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 6px 8px;
}

.user-details-page .input-status-row .status-text {
  grid-column: 1 / -1;
  overflow-wrap: anywhere;
}

.user-details-page .input-button-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.user-details-page .input-button-container .user-input {
  flex: 1 1 240px;
  width: auto;
}

.user-details-page .open-link-btn {
  flex: 0 1 auto;
  width: auto;
  max-width: 100%;
  min-height: 44px;
  margin: 0;
  padding: 10px 14px;
  font-size: 14px;
  line-height: 20px;
  white-space: normal;
}

.user-details-page .operational-hold-grid {
  grid-template-columns: minmax(0, 1fr) minmax(0, 2fr);
}

.user-details-page .operational-hold-field {
  grid-template-rows: auto auto;
  gap: 6px;
}

.user-details-page .operational-hold-card__header > div {
  min-width: 0;
  overflow-wrap: anywhere;
}

.user-details-page .operational-hold-badge,
.user-details-page .influencer-toggle__slider {
  flex-shrink: 0;
}

.user-details-page .operational-hold-check {
  min-width: 0;
  align-items: flex-start;
  padding: 3px 0;
}

.user-details-page .operational-hold-check input {
  margin-top: 1px;
}

.user-details-page .influencer-toggle-row {
  flex-wrap: wrap;
  box-sizing: border-box;
  min-height: 44px;
  padding: 8px 12px;
}

.user-details-page .fusco-card__header {
  flex-wrap: wrap;
}

.user-details-page .fusco-card__grid {
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
}

.user-details-page :is(.fusco-value, .fusco-status, .fusco-state) {
  overflow-wrap: anywhere;
}

.user-details-page .button-actions {
  gap: 12px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
}

.user-details-page .profile-programme-note {
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
}

.user-details-page .profile-programme-note :deep(.user-expiring-note__label) {
  font-size: 13px;
}

.user-details-page .profile-programme-note :deep(textarea) {
  height: 110px;
  min-height: 90px;
}

.user-details-page :is(.button-container, .button-inline-group) {
  margin: 0;
}

.user-details-page .button-actions .button-container {
  min-height: 44px;
  padding: 10px 16px;
}

.user-details-page .icon-button {
  width: 44px;
  height: 44px;
}

.user-details-page .modal {
  box-sizing: border-box;
  width: min(560px, calc(100% - 24px));
  max-height: 75dvh;
}

.user-details-page .modal-header {
  min-height: 36px;
  padding: 0 44px 10px 0;
  text-align: left;
}

.user-details-page .modal-title {
  line-height: 22px;
  overflow-wrap: anywhere;
}

.user-details-page .modal-close {
  width: 44px;
  height: 44px;
}

@container anagrafica (max-width: 820px) {
  .user-details-page .grid-container {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@container anagrafica (max-width: 650px) {
  .user-details-page .operational-hold-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .user-details-page .operational-hold-card textarea.operational-hold-note {
    height: 80px !important;
    max-height: none !important;
    padding: 10px 12px !important;
    line-height: 20px !important;
    overflow: auto !important;
    resize: vertical !important;
  }
}

@container anagrafica (max-width: 560px) {
  .user-details-page .grid-container {
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
  }

  .user-details-page :is(.user-input, .user-textarea) {
    font-size: 16px;
  }

  .user-details-page .input-button-container .user-input {
    flex-basis: 100%;
    width: 100%;
  }

  .user-details-page .operational-hold-button {
    width: 100%;
  }
}

  </style>
  
